/**
PW Tab Content

"Sliding Pane" style content box. Can be paired with a PW Tabs component for control, but not required
Expects PW TabContentPane components as children

Options (props)
- activeTabKey [string]: 'key' of the active child Tab
- childOrder: array of child keys that must exactly match the number of child components. Also controls render/panel order

example configuration:
  <ReactBase.TabContent>
    <ReactBase.TabContentPane key="foo">
      Content
    </ReactBase.TabContentPane>
  </ReactBase.TabContent>

**/

import _ from 'lodash'
import React from 'react'
import T from 'prop-types'
import ReactDOM from 'react-dom'
import ScrollBars from './scrollbars/ScrollBars'

class TabContent extends React.Component {
  static propTypes = {
    activeTabKey: T.string.isRequired,
    children: T.any,
    style: T.object,
    className: T.string,
    scrollBars: T.bool,
    scrollBarsOutside: T.bool
  }

  static defaultProps = {
    className: '',
    scrollBars: false,
    scrollBarsOutside: false
  }

  state = {
    activeTabKeyIndex: 0,
    orderedChildKeys: []
  }

  UNSAFE_componentWillMount() {
    this._updateKeyStore(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._updateKeyStore(nextProps)
  }

  _updateKeyStore = (props) => {
    const orderedChildKeys = _(this.props.children)
      .compact()
      .map(child => child.key)
      .value()
    this.setState({
      childKeys: orderedChildKeys,
      activeTabKeyIndex: orderedChildKeys.indexOf(props.activeTabKey)
    })
  }

  _onScroll = () => {
    // Some things like input focusing can make the browser scroll the overflow:hidden
    // container and screw up the alignment, so prevent that from happening.
    const el = ReactDOM.findDOMNode(this)
    if (el && el.scrollLeft > 0) {
      el.scrollLeft = 0
    }
    if (el && el.scrollTop > 0) {
      el.scrollTop = 0
    }
  }

  _renderContent = () => {
    if (this.props.scrollBars) {
      return (
        <ScrollBars horizontal={false} outside={this.props.scrollBarsOutside}>
          {React.Children.map(this.props.children, this._renderChildren)}
        </ScrollBars>
      )
    } else {
      return React.Children.map(this.props.children, this._renderChildren)
    }
  }

  _renderChildren = (childComponent) => {
    if (!childComponent) return childComponent
    const childKey = childComponent.key
    const isActive = childKey === this.props.activeTabKey
    const hidden =
      isActive ? false
      : this.state.activeTabKeyIndex > this.state.childKeys.indexOf(childKey)
        ? 'left'
        : 'right'
    return React.cloneElement(
      childComponent, {
        key: childKey,
        hidden: hidden
      }
    )
  }

  render() {
    return (
      <div
        className={`tab_content ${this.props.className}`}
        onScroll={this._onScroll}
        style={this.props.style}
      >
        {this._renderContent()}
      </div>
    )
  }
}


export default TabContent
